import React, { useState, useContext } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import './Auth.css';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); 

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/register`, {
        email,
        password
      });

      // Save user + token
      login(response.data.access_token, response.data.user);
      toast.success('Account created successfully!');

      // Redirect restore logic
      const redirect = searchParams.get('redirect');
      const text = searchParams.get('text');

      if (redirect === '/checker' && text) {
        return navigate('/checker', {
          state: { text: decodeURIComponent(text) }
        });
      }

      if (redirect) return navigate(redirect);

      navigate('/dashboard');

    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR WITH LOGO (Same as Login) */}
      <nav className="auth-nav fade-in">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/icons/logo-512.png" alt="GrammAA Logo" className="nav-logo" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      <div className="auth-box glass-panel glow-effect fade-in">
        <div className="auth-header" data-testid="signup-header">
          <h1>Create Account</h1>
          <p>Join GrammAA and start perfecting your writing</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">

          {/* EMAIL */}
          <div className="form-group">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="glass-input"
              data-testid="signup-email-input"
            />
          </div>

          {/* PASSWORD */}
          <div className="form-group">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="glass-input"
              data-testid="signup-password-input"
            />
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="form-group">
            <Label htmlFor="confirmPassword">Confirm Password</Label>
            <Input
              id="confirmPassword"
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="glass-input"
              data-testid="signup-confirm-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="glass-btn auth-submit-btn"
            data-testid="signup-submit-btn"
          >
            {loading ? 'Creating Account...' : 'Sign Up'}
          </Button>
        </form>

        <div className="auth-footer">
          <p>
            Already have an account?{' '}
            <Link to="/login" className="auth-link" data-testid="signup-login-link">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
